module.exports = __webpack_public_path__ + "static/media/Schoolhealth1.376ffc79.jpg";